module.exports = __webpack_public_path__ + "img/p12.aa40d013.png";